var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.$route.path === "/login" ? "login" : "app",
      attrs: { id: "application" }
    },
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href: "https://use.fontawesome.com/releases/v5.7.2/css/all.css",
          integrity:
            "sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7RrhN7udi9RwhKkMHpvLbHG9Sr",
          crossorigin: "anonymous"
        }
      }),
      _vm._v(" "),
      _c("v-dialog"),
      _vm._v(" "),
      _c("notifications"),
      _vm._v(" "),
      _vm.$route.path !== "/login" && _vm.$route.path !== "/"
        ? _c("div", [_c("sidebar")], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.uploadPercentage != 0
        ? _c("vm-progress", {
            attrs: {
              id: "uploadProgressCircle",
              type: "circle",
              percentage: _vm.uploadPercentage,
              width: 75
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }